/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import React, { useState } from 'react';

export default function FormLogin() {
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState();

  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post('/api/v1/login', { ...form })
      .then(({ data }) => {
        if (data.success) {
          window.location.href = '/';
        } else {
          setErrorMessage(true);
        }
      })
      .catch(() => {
        setErrorMessage(true);
      });
  };
  return (
    <div className='main_content shop pb-100 mt-100'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-xl-6 col-md-10'>
            <div className='login_wrap widget-taber-content p-30 background-white border-radius-5'>
              <div className='padding_eight_all bg-white'>
                <div className='heading_s1'>
                  <h3 className='mb-30'>Đăng nhập</h3>
                </div>
                <form
                  action=''
                  method=''
                  onSubmit={(e) => {
                    handleLogin(e);
                  }}
                >
                  <div className='form-group'>
                    <label>Email</label>
                    <input
                      type='text'
                      name='email'
                      placeholder=''
                      required
                      class='form-control'
                      onChange={(e) => {
                        handleForm(e.target.value, 'email');
                      }}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Mật khẩu</label>
                    <input
                      id='password-field'
                      type='password'
                      name='password'
                      placeholder=''
                      required
                      class='form-control'
                      onChange={(e) => {
                        handleForm(e.target.value, 'password');
                      }}
                    />
                  </div>
                  <p className='text-danger'>
                    {errorMessage ? 'Tên tài khoản hoặc mật khẩu sai' : ''}
                  </p>
                  <div className='login_footer form-group d-flex justify-content-between'>
                    <div className='chek-form'>
                      <div className='custome-checkbox d-flex align-items-center'>
                        <input
                          style={{ marginRight: '5px' }}
                          type='checkbox'
                          name='checkbox'
                          id='exampleCheckbox1'
                          value=''
                        />
                        <label for='exampleCheckbox1' style={{ margin: 0 }}>
                          <span>Giữ trạng thái đăng nhập</span>
                        </label>
                      </div>
                    </div>
                    <a className='text-muted' href='/quen-mat-khau'>
                      Quên mật khẩu?
                    </a>
                  </div>
                  <div className='form-group'>
                    <button
                      type='submit'
                      className='btn btn-fill-out btn-block'
                      name='login'
                    >
                      Đăng Nhập
                    </button>
                  </div>
                </form>
                <div className='divider-text-center mt-15 mb-15'>
                  <span> hoặc</span>
                </div>
                {/* <ul className='btn-login list_none text-center mb-15'>
                  <li>
                    <a href='#' className='btn btn-facebook'>
                      <i className='ti-facebook mr-5'></i>Facebook
                    </a>
                  </li>
                  <li>
                    <a href='#' className='btn btn-google'>
                      <i className='ti-google mr-5'></i>Google
                    </a>
                  </li>
                </ul> */}
                <div className='text-muted text-center'>
                  Chưa có tài khoản?{' '}
                  <a href='/dang-ky-tai-khoan'>Tạo tài khoản</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
